import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'autoDecimal',
})
export class AutoDecimalPipe implements PipeTransform {
  transform(value: any, len: number = 2): any {
    try {
      if ([value as string].filter((v) => v === '.').length > 1) {
        throw new SyntaxError('Invalid value passing');
      }
      if (value) {
        if (+value.includes('.')) {
          const decimal = (value as string).split('.')[1].length;
          if (decimal < len) {
            return `${value}${'0'.repeat(len - decimal)}`;
          } else {
            return value;
          }
        } else {
          return `${value}.${'0'.repeat(len)}`;
        }
      } else {
        return value;
      }
    } catch (error) {
      throw new Error(error.message);
    }
  }
}
